/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInChatListItemClassification } from './linkedInChatListItemClassification';
import type { LinkedInChatListItemConnectionState } from './linkedInChatListItemConnectionState';
import type { LinkedInChatListItemDraftStatus } from './linkedInChatListItemDraftStatus';
import type { LinkedInChatListItemLastMessageDirection } from './linkedInChatListItemLastMessageDirection';
import type { LinkedInChatListItemManualClassification } from './linkedInChatListItemManualClassification';

/**
 * One row in ``GET /inbox/chats``.
 */
export interface LinkedInChatListItem {
  id: string;
  channel?: 'linkedin';
  job_candidate_id: string;
  /** @maxLength 200 */
  candidate_name: string;
  candidate_avatar_url?: string | null;
  candidate_headline?: string | null;
  /** @maxLength 500 */
  snippet: string;
  last_message_at: string;
  connection_state: LinkedInChatListItemConnectionState;
  classification?: LinkedInChatListItemClassification;
  manual_classification?: LinkedInChatListItemManualClassification;
  classification_confidence?: number | null;
  draft_status?: LinkedInChatListItemDraftStatus;
  /** @minimum 0 */
  unread_count: number;
  last_message_direction?: LinkedInChatListItemLastMessageDirection;
  last_sender_name?: string | null;
  last_sender_avatar_url?: string | null;
}
